import { Draggable } from "react-beautiful-dnd";
import { Scope, useFormApi, useFieldApi, Checkbox, useFieldState } from "informed";
import { FixedCommentSetFormModel } from "../types";
import { useState, useEffect } from "react";
import { Required, RequiredNotBlank } from "../../../forms/validation/Required";
import * as React from "react";
import { TextBox } from "../../../forms/informedv2/TextBox";
import { FixedCommentSetTypeEnum } from "../../../misc/api/FixedComments/FixedCommentSetTypes";
import { nameof } from "ts-simple-nameof";
import { FixedComment } from "webportalclient";

interface FixedCommentEntryProps {
    field: string;
    remove: () => void;
    initialValue: FixedComment;
    index: number;
    editMode: boolean;
}

const FixedCommentEntryFields = ({ field, remove, initialValue, index, editMode }: FixedCommentEntryProps): JSX.Element => {

    const formApi = useFormApi<FixedCommentSetFormModel>();

    const [followOnAvailable, setFollowOnAvailable] = useState<boolean>(initialValue?.followOnCommentAvailable);
    const fieldApi = useFieldApi<number>(`${field}.${nameof<FixedComment>(fc => fc.displayOrder)}`);

    const setTypeSelected = useFieldState<FixedCommentSetTypeEnum>(nameof<FixedCommentSetFormModel>(fc => fc.SetType));

    useEffect(() => {
        var value = fieldApi.getValue();

        fieldApi.setValue(index);

    }, [index]);

    const handleUpdate = () => {
        const followOnCommentAvailable = formApi.getValue<boolean>(field + '.followOnCommentAvailable');

        setFollowOnAvailable(followOnCommentAvailable);
    };

    const ValidateFollowOnAnnotation = (value: string) => {
        const followOnCommentRequired = formApi.getValue(field + '.followOnCommentRequired');

        if (followOnCommentRequired == true) {
            return Required(value.trim());
        }
    };

    return (
        <Draggable draggableId={`drag-${field}`} index={index} >
            {provided => (<Scope scope={field}>
                <div className="panel-body bottom" ref={provided.innerRef}
                    {...provided.draggableProps}>
                    <i {...provided.dragHandleProps} className="fas fa-grip-vertical"></i>&nbsp;
                    <div className="col-md-12">
                        <div className="form-group col-md-6">
                            <label htmlFor={`display-text-${field}`}>Display Text</label>
                            <TextBox initialValue={initialValue.comment} id={`display-text-${field}`} field={nameof<FixedComment>(fc => fc.comment)} validate={RequiredNotBlank} />
                        </div>
                        <div className="form-group col-md-5">
                            <label htmlFor={`description-text-${field}`}>Description</label>
                            <TextBox initialValue={initialValue.description} id={`description-text-${field}`} field={nameof<FixedComment>(fc => fc.description)} />
                        </div>
                        <div className="col-md-1 pull-right" >
                            <button type="button" className="close" aria-label="Remove" onClick={() => remove()}><span aria-hidden="true">&times;</span></button>
                        </div>
                    </div>
                    <div className="col-md-12" >
                        <div className="form-group col-md-6" hidden={setTypeSelected.value !== FixedCommentSetTypeEnum.Technician}>
                            <label htmlFor={`comment-available-${field}`} className="right">Follow On Comment Available</label>
                            <Checkbox initialValue={initialValue.followOnCommentAvailable} onChange={() => handleUpdate()} id={`comment-available-${field}`} field={nameof<FixedComment>(fc => fc.followOnCommentAvailable)} />
                        </div>
                        <div className="form-group col-md-6" hidden={!followOnAvailable || setTypeSelected.value !== FixedCommentSetTypeEnum.Technician}>
                            <label htmlFor={`comment-required-${field}`} className="right">Follow On Comment Required</label>
                            <Checkbox initialValue={initialValue.followOnCommentRequired} id={`comment-required-${field}`} field={nameof<FixedComment>(fc => fc.followOnCommentRequired)} />
                        </div>
                        <div className="form-group col-md-12" hidden={!followOnAvailable || setTypeSelected.value !== FixedCommentSetTypeEnum.Technician}>
                            <label htmlFor={`comment-annotation-${field}`}>Follow On Comment Annotation</label>
                            <TextBox initialValue={initialValue.followOnCommentAnnotation} id={`comment-annotation-${field}`} field={nameof<FixedComment>(fc => fc.followOnCommentAnnotation)} validate={ValidateFollowOnAnnotation} />
                        </div>
                        <div className="form-group col-md-12" hidden={!editMode}>
                            <label htmlFor={`comment-hidden-${field}`} className="right">Hidden</label>
                            <Checkbox initialValue={initialValue.disabled} id={`comment-hidden-${field}`} field={nameof<FixedComment>(fc => fc.disabled)} />
                        </div>
                    </div>
                    <div hidden={true}>
                        <label htmlFor={`comment-order-${field}`}>Order</label>
                        <TextBox initialValue={initialValue.displayOrder.toString()} id={`comment-order-${field}`} field={nameof<FixedComment>(fc => fc.displayOrder)} validate={(value) => Number.parseInt(value) != 0 ? Required(value) : undefined} />
                    </div>
                </div>
            </Scope>)}
        </Draggable>

    )
};

export default FixedCommentEntryFields;

